// @flow

import {
  // TREE,
  REPORTS,
  REPORTS_ERRORS,
  IS_LOADING,
} from '../constants'

export default {
  [REPORTS]: [],
  [REPORTS_ERRORS]: '',
  [IS_LOADING]: false,
}
